// Cinematic Filmistani logo — a stylized "F" film-strip mark
export default function Logo({ size = 28, withText = true, testid }) {
  return (
    <div className="flex items-center gap-2.5" data-testid={testid}>
      <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Filmistani logo">
        {/* Outer film frame */}
        <rect x="2" y="2" width="36" height="36" rx="6" fill="#0A0A0A" stroke="#E50914" strokeWidth="2"/>
        {/* Sprocket holes — left */}
        <rect x="5" y="6" width="3" height="3" rx="0.5" fill="#E50914"/>
        <rect x="5" y="12" width="3" height="3" rx="0.5" fill="#E50914"/>
        <rect x="5" y="18" width="3" height="3" rx="0.5" fill="#E50914"/>
        <rect x="5" y="24" width="3" height="3" rx="0.5" fill="#E50914"/>
        <rect x="5" y="30" width="3" height="3" rx="0.5" fill="#E50914"/>
        {/* Stylized "F" */}
        <path d="M14 9 L33 9 L33 14 L20 14 L20 18 L30 18 L30 23 L20 23 L20 32 L14 32 Z" fill="#FFFFFF"/>
        {/* Electric-blue accent dot (AI signal) */}
        <circle cx="32" cy="32" r="3" fill="#007AFF"/>
      </svg>
      {withText && (
        <span className="font-display text-xl font-extrabold tracking-tight text-white">
          Filmistani
        </span>
      )}
    </div>
  );
}
